import { Button } from "@/components/ui/button";
import heroBg from "@/assets/rubini-hero.jpeg";
import heroBgMobile from "@/assets/rubini-hero-mobile.jpeg";
const Hero = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
      });
    }
  };
  return (
    <section className="relative h-screen min-h-[600px] flex items-start md:items-start pt-28 md:pt-32">
      {/* Background images: mobile vs desktop */}
      <div
        className="absolute inset-0 bg-cover bg-center md:hidden"
        style={{ backgroundImage: `url(${heroBgMobile})` }}
      />
      <div
        className="absolute inset-0 bg-cover bg-center hidden md:block"
        style={{ backgroundImage: `url(${heroBg})` }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/25 md:bg-gradient-to-l md:from-black/45 md:via-black/20 md:to-transparent" />

      {/* Content */}
      <div className="container relative z-8 mx-auto px-4 pb-8 md:pb-0">
        <div className="max-w-3xl mx-auto md:max-w-3xl lg:max-w-4xl md:ml-auto md:mr-0 text-white animate-fade-in-up text-center md:text-right">


          {/* Headline */}
          <h1 className="mb-4 md:mb-6 drop-shadow-lg uppercase text-2xl md:text-3xl lg:text-4xl" style={{ fontFamily: 'Verdana, sans-serif' }}>
            <span className="md:hidden">Dal 1983 al tuo fianco per giardino e animali</span>
            <span className="hidden md:inline">Dal 1983 ci prendiamo cura del tuo giardino e dei tuoi animali, sia da allevamento che domestici</span>
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg lg:text-xl mb-6 md:mb-8 text-white/90 leading-relaxed" style={{ fontFamily: 'Verdana, sans-serif' }}>
            <span className="md:hidden">A Magione trovi tutto per animali, giardino e allevamento.</span>
            <span className="hidden md:inline">Presso la nostra sede di Magione troverai tutto ciò di cui hai bisogno per la cura dei tuoi animali, del tuo giardino e dei tuoi allevamenti.</span>
          </p>


          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-end">

            <Button
              onClick={() => scrollToSection("prodotti")}
              size="lg"
              className="btn-cta rounded-full px-8 py-6 text-base font-semibold uppercase"
              style={{ fontFamily: 'Verdana, sans-serif' }}
            >
              Scopri i nostri prodotti
            </Button>
            <Button
              onClick={() => scrollToSection("contatti")}
              size="lg"
              className="btn-secondary rounded-full px-8 py-6 text-base font-semibold uppercase"
              style={{ fontFamily: 'Verdana, sans-serif' }}
            >
              Vieni a trovarci
            </Button>
          </div>

          {/* Scroll Down Arrow - Mobile Only */}
          <div className="md:hidden mt-16 flex justify-center animate-bounce">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Hero;
